export const routes = {
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  dashboard: '/app/dashboard',
  profile: '/app/profile',
  orders: '/app/orders',
  deals: '/app/deals',
  products: '/app/products',
  brands: '/app/brands',
  customers: '/app/customers',
  setting: '/app/setting',
  categories: '/app/categories',
  bulkProductUpdate: '/app/products/bulkproductupdate',
  uploadMedia: '/app/products/uploadmedia',
  pages: '/app/pages',
  addPage: '/app/pages/add',
  newCustomer: '/app/newcustomer'
}
